import type { SweetAlertIcon } from "sweetalert2";

export type AlertType = {
  visible: boolean;
  title: string;
  text: string;
  icon: SweetAlertIcon;
  confirmButtonText: string;
  confirmButtonColor: string;
  onConfirm?: () => void;
  showCancelButton?: boolean;
  cancelButtonText?: string;
  cancelButtonColor?: string;
  onCancel?: () => void;
};

export const resetAlert = (): AlertType => {
  return {
    visible: false,
    title: " ",
    text: " ",
    icon: "" as SweetAlertIcon,
    confirmButtonText: "",
    confirmButtonColor: "",
    onConfirm: () => {},
    showCancelButton: false,
    cancelButtonText: "",
    cancelButtonColor: "",
    onCancel: () => {},
  };
};

export const formatDate = (seconds: number, nanoseconds: number): string => {
  const milliseconds = seconds * 1000 + nanoseconds / 1000000;
  const date = new Date(milliseconds);
  return date.toLocaleDateString("es-ES");
};

export const formatDateTime = (
  seconds: number,
  nanoseconds: number
): string => {
  const milliseconds = seconds * 1000 + nanoseconds / 1000000;
  const date = new Date(milliseconds);
  const formattedDate = date.toLocaleDateString("es-ES");
  const formattedTime = date.toLocaleTimeString("es-ES");
  return `${formattedDate} - ${formattedTime}`;
};
